let questions = document.getElementsByClassName('faq__question');
if (questions.length > 0) {
	for (i = 0; i < questions.length; i++) {
		questions[i].addEventListener('click', function() {
			this.classList.toggle('active');

			let answer = this.nextElementSibling;
			if (answer.style.maxHeight) {
				this.setAttribute('aria-expanded', 'false');
				answer.style.maxHeight = null;
			} else {
				this.setAttribute('aria-expanded', 'true');
				answer.style.maxHeight = answer.scrollHeight + 'px';
			}
		});
	}
}
